import { Config } from "./config/Config";

export class WixApiCall {
  protected baseUrl: string;
  constructor(baseUrl:string = Config.API_BASE_URL) {
    this.baseUrl = baseUrl;
  }
}